import {
  SET_MEASUREMENT_TOOL,
  DISABLE_MEASUREMENT_TOOLS,
  ADD_POI_POINT,
  RESET_ADD_POI_TOOL,
  RESET_MANAGAE_POI_TOOL,
  ADD_HOTEL_POINT,
  RESET_ADD_HOTEL_TOOL,
  RESET_MANAGAE_HOTEL_TOOL,
  TOGGLE_SPATIAL_ANALYSIS,
  CHANGE_SPATIAL_ANALYSIS_CONFIG,
  CLEAR_SPATIAL_ANALYSIS_CONFIG,
  ONCLICK_PARCEL,
  RECTANGLE_ZOOM_IN,
  BUILDING_DRAW_TOOL_TOGGLE,
  BUILDING_DRAW_TOOL_GET_POINT,
  BUILDING_DRAW_TOOL_DATA,
  BUILDING_DRAW_TOOL_PARCELS,
  BUILDING_DRAW_TOOL_VALIDATE,
  RECTANGLE_BLOCKING_TOGGLE,
  BUILDING_DRAW_TOOL_PDF,
  FETCH_DRAW_TOOL_LIMITS_REQUEST,
  FETCH_DRAW_TOOL_LIMITS_SUCCESS,
  FETCH_DRAW_TOOL_LIMITS_FAIL,
} from '../constants';

const initialState = {
  map_tools: {
    getPoint: {},
    measurePolyLine: {},
    measurePolygon: {},
    addPoi: {
      selectedPoint: null,
    },
    addHotel: {
      selectedPoint: null,
    },
  },
  spatial_analysis: {
    layer_from: null,
    isEnabled: false,
    queryFunction: null,
    layer_to: null,
    bufor_size: null,
  },
  isMeasuring: false,
  currentTool: null,
  parcelState: false,
  isZooming: false,
  isZoomBlocked: false,
  buildingDrawTool: {
    display: false,
    validation: {
      intersect: true,
      wysokoscMax: null,
      wrongPoints: [],
    },
    print: false,
    project: {
      position: [],
      data: null,
    },
    parcels: null,
    limits: null,
    areFetchingLimits: false,
    areLimitsFetched: false,
  },
};

const setMeasurementTool = (state, action) => ({
  ...state,
  isMeasuring: true,
  currentTool: action.payload.tool,
});

const disableTool = (state) => ({
  ...state,
  isMeasuring: false,
  currentTool: null,
});

const addPoiPoint = (state, action) => ({
  ...state,
  map_tools: {
    ...state.map_tools,
    addPoi: {
      selectedPoint: action.payload.point,
    },
  },
});
const resetAddPoi = (state) => ({
  ...state,
  map_tools: {
    ...state.map_tools,
    addPoi: {
      selectedPoint: null,
    },
  },
  isMeasuring: false,
  currentTool: null,
});

const resetManagePoi = state => ({
  ...state,
  currentTool: null,
});

const addHotelPoint = (state, action) => ({
  ...state,
  map_tools: {
    ...state.map_tools,
    addHotel: {
      selectedPoint: action.payload.point,
    },
  },
});

const resetManageHotel = state => ({
  ...state,
  currentTool: null,
});

const resetAddHotel = (state) => ({
  ...state,
  map_tools: {
    ...state.map_tools,
    addHotel: {
      selectedPoint: null,
    },
  },
  isMeasuring: false,
  currentTool: null,
});

const toggleAnalysis = (state) => ({
  ...state,
  spatial_analysis: {
    ...state.spatial_analysis,
    isEnabled: !state.spatial_analysis.isEnabled,
  },
});

const changeAnalysisConfig = (state, action) => ({
  ...state,
  spatial_analysis: {
    ...state.spatial_analysis,
    [action.payload.key]: action.payload.value,
  },
});

const clearAnalysis = (state) => ({
  ...state,
  spatial_analysis: {
    layer_from: null,
    isEnabled: false,
    queryFunction: null,
    layer_to: null,
    bufor_size: null,
  },
});

const onClickParcel = (state, action) => ({
  ...state,
  parcelState: action.payload.prop,
});

const zoomingRectangle = (state, action) => ({
  ...state,
  isZooming: action.payload.prop,
});

const blockingRectangle = (state, action) => ({
  ...state,
  isZoomBlocked: action.payload.prop,
});


const BDTtoggle = (state, action) => ({
  ...state,
  buildingDrawTool: { ...state.buildingDrawTool, display: action.payload.display },
});

const BDTprint = (state, action) => ({
  ...state,
  buildingDrawTool: { ...state.buildingDrawTool, print: action.payload.print },
});

const BDTvalidation = (state, action) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    validation: action.payload.valid,
  },
});

const BDTprojectPosition = (state, action) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    project: {
      ...state.buildingDrawTool.project,
      position: action.payload.position,
    },
  },
});

const BDTprojectData = (state, action) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    project: {
      ...state.buildingDrawTool.project,
      data: action.payload.data,
    },
  },
});
const BDTparcels = (state, action) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    parcels: action.payload.parcels,
  },
});
const getLimitsSuccess = (state, action) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    limits: action.payload,
    areFetchingLimits: false,
    areLimitsFetched: true,
  },
});

const getLimitsFail = (state) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    areFetchingLimits: false,
    areLimitsFetched: false,
  },
});

const getLimitsFetching = (state) => ({
  ...state,
  buildingDrawTool: {
    ...state.buildingDrawTool,
    areFetchingLimits: true,
    areLimitsFetched: false,
  },
});

export default function reducer(state = initialState, action) {
  return ({
    [SET_MEASUREMENT_TOOL]: setMeasurementTool,
    [DISABLE_MEASUREMENT_TOOLS]: disableTool,
    [ADD_POI_POINT]: addPoiPoint,
    [RESET_ADD_POI_TOOL]: resetAddPoi,
    [RESET_MANAGAE_POI_TOOL]: resetManagePoi,
    [ADD_HOTEL_POINT]: addHotelPoint,
    [RESET_ADD_HOTEL_TOOL]: resetAddHotel,
    [RESET_MANAGAE_HOTEL_TOOL]: resetManageHotel,
    [TOGGLE_SPATIAL_ANALYSIS]: toggleAnalysis,
    [CHANGE_SPATIAL_ANALYSIS_CONFIG]: changeAnalysisConfig,
    [CLEAR_SPATIAL_ANALYSIS_CONFIG]: clearAnalysis,
    [ONCLICK_PARCEL]: onClickParcel,
    [RECTANGLE_ZOOM_IN]: zoomingRectangle,
    [RECTANGLE_BLOCKING_TOGGLE]: blockingRectangle,
    [BUILDING_DRAW_TOOL_TOGGLE]: BDTtoggle,
    [BUILDING_DRAW_TOOL_VALIDATE]: BDTvalidation,
    [BUILDING_DRAW_TOOL_GET_POINT]: BDTprojectPosition,
    [BUILDING_DRAW_TOOL_DATA]: BDTprojectData,
    [BUILDING_DRAW_TOOL_PARCELS]: BDTparcels,
    [BUILDING_DRAW_TOOL_PDF]: BDTprint,
    [RECTANGLE_BLOCKING_TOGGLE]: blockingRectangle,
    [FETCH_DRAW_TOOL_LIMITS_SUCCESS]: getLimitsSuccess,
    [FETCH_DRAW_TOOL_LIMITS_REQUEST]: getLimitsFetching,
    [FETCH_DRAW_TOOL_LIMITS_FAIL]: getLimitsFail,
  }[action.type] || (s => s)) (state, action);
}



// WEBPACK FOOTER //
// src/reducers/mapTools.js